<span *ngIf="value">
                        <i *ngIf="value === 'Table Tennis'" class="material-icons">sports_tennis</i>
                        <i *ngIf="value !== 'Table Tennis'" class="material-icons">sports_{{value.toLowerCase()}}</i>
  <span>{{value}}</span>
</span>
